module.exports = __webpack_public_path__ + "img/ic-img-upload.48c7e1e2.svg";